import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { flattenErrors } from './ErrorHelpers';

export class MakePifPaymentComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { renderModal, showModal } = this.state;
        console.log("pif component state:", this.state);
        console.log("pif component props:", this.props);
        return (
            <>
                <div onClick={() => this.setState({
                    showModal: true,
                    renderModal: true
                })} className="" href="javascript:void(220221)">
                    <a href="javascript:void(220221)" class="btn btn-block btn-sm btn-primary btn-pay text-white">PAY BALANCE</a>
                </div>
                {renderModal &&
                    <MakePifPaymentModalComponent
                        accountNumber={this.props.accountNumber}
                        amount={this.props.pifBalance}
                        pifPrice={ this.props.pifPrice}
                        pifBalance={this.props.pifBalance}
                        hasPaid={this.props.hasPaid}
                        pifSavings={this.props.pifSavings}
                        showModal={showModal}
                        handleClose={() => {
                            this.setState({ showModal: false });
                        }}
                        onExited={() => {
                            this.setState({ renderModal: false });
                        }} />}
            </>
        );
    }
}


class MakePifPaymentModalComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Amount: props.amount,
            AccountNumber: props.accountNumber,
            PifPrice: props.pifPrice,
            PifBalance: props.pifBalance,
            hasPaid: props.hasPaid,
            pifSavings: props.pifSavings
        };
        this.removePifPaymentContainer = this.removePifPaymentContainer.bind(this);
    }

    handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    removePifPaymentContainer() {
        document.querySelector("#pifPayContainer").remove();
    }   
    

    save = (e) => {
        this.setState({
            isSaving: true,
            errors: null
        },
            () => {
                fetch(`/api/talent/makepayment`,
                    {
                        method: "POST",
                        body: JSON.stringify(this.state),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(req => req.json())
                    .then(resp => {
                        if (resp.success) {
                            this.setState({resp});
                        } else if (resp.errors) {
                            if (resp.errors.detail) {
                                this.setState({
                                    errors: [resp.errors.detail],
                                    isSaving: false
                                });
                            } else {
                                const flattened = flattenErrors(resp.errors);
                                this.setState({
                                    errors: flattened,
                                    isSaving: false
                                });
                            }
                        } else {
                            this.setState({
                                errors: ["A general error occurred. Please contact your system administrator."],
                                isSaving: false
                            });
                        }
                    });
            });
    }

    render() {
        const { showModal, handleClose, onExited } = this.props;
        const years = Array.from(new Array(20), (x, i) => i + new Date().getFullYear());

        console.log(this.props);
        return (
            <Modal isOpen={showModal} onClosed={onExited}>
                <ModalHeader toggle={handleClose}>
                    Payout Remaining Balance ${this.state.PifBalance}
                </ModalHeader>
                <ModalBody>
                    {this.state.resp && <div style={{textAlign: "center"}}>
                        <h4>Thanks for your payment!</h4>
                        <p>
                            Amount: ${this.state.resp.amount.toFixed(2)} <br/>
                            Approval Code: {this.state.resp.approvalCode}
                        </p>
                        {this.removePifPaymentContainer()}
                    </div>}
                    {!this.state.resp && <div>
                        <div className="form-row">
                            <input hidden type="text" name="Amount" value={this.state.PifBalance} onChange={this.handleInputChange}
                                    placeholder="Enter your payment amount" className="form-control" />
                            <div className="form-group col-8">
                                <label className="sr-only">Card Number</label>
                                <input type="tel" name="CreditCardNumber" value={this.state.CreditCardNumber} onChange={this.handleInputChange}
                                       placeholder="4111 0001 1234 4567" className="form-control" />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="col-6 form-group">
                                <label className="sr-only">Exp. Month</label>
                                <select name="ExpirationMonth" className="form-control" value={this.state.ExpirationMonth} onChange={this.handleInputChange}>
                                    <option>Month</option>
                                    <option value="1">January</option>
                                    <option value="2">February</option>
                                    <option value="3">March</option>
                                    <option value="4">April</option>
                                    <option value="5">May</option>
                                    <option value="6">June</option>
                                    <option value="7">July</option>
                                    <option value="8">August</option>
                                    <option value="9">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </select>
                            </div>
                            <div className="col-4 form-group">
                                <label className="sr-only">Exp. Year</label>
                                <select name="ExpirationYear" className="form-control" value={this.state.ExpirationYear} onChange={this.handleInputChange}>
                                    <option>Year</option>
                                    {years.map(y => <option value={y}>{y}</option>)}
                                </select>
                            </div>
                            <div className="col-2 form-group">
                                <label className="sr-only">CVV Code</label>
                                <input type="tel" name="CvvCode" className="form-control" maxlength="4" placeholder="CVV" style={{ width: "60px" }} value={this.state.CvvCode} onChange={this.handleInputChange} />
                            </div>
                        </div>
                    </div>}
                </ModalBody>
                <ModalFooter>
                    {!this.state.resp && <>
                        {this.state.isSaving && <div className="float-left">
                            Sending...
                        </div>}
                        {this.state.errors && <div className="float-left text-left">
                            {this.state.errors.map(e => <div key={e}>{e}</div>)}
                        </div>}
                        {!this.state.errors && !this.state.isSaving && <img src="/PayTraceSeal_3l.png" className="mr-auto" style={{height: '40px'}} />}
                        <Button onClick={this.save} disabled={this.state.isSaving}>
                            Pay Balance
                        </Button>
                    </>}
                    {this.state.resp && <Button onClick={this.props.handleClose}>
                        Close Window
                    </Button>}
                </ModalFooter>
            </Modal>
        );
    }
}
